import navratri from '../config/navratri.json';
import type { DiscountCampaign } from '../types/discount';
export const navratriCampaign: DiscountCampaign = navratri;
export function isCampaignActive(campaign: DiscountCampaign | null, now = Date.now()): boolean {
  return Boolean(campaign?.enabled && Number.isFinite(campaign.percent) && campaign.percent > 0 && campaign.percent <= 90 && Date.parse(campaign.startAt) <= now && now <= Date.parse(campaign.endAt));
}
export function scheduledCampaign(now = Date.now()): DiscountCampaign | null {
  return isCampaignActive(navratriCampaign, now) ? navratriCampaign : null;
}
